import Phaser from "phaser";
import * as Helpers from "../../configs/helpers";

export default class Pole extends Phaser.GameObjects.Sprite {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y, 'object_pole');
    this.scene.add.existing(this);

    // Styling //
    this.setOrigin(0.5, 1);
    this.setActive(false).setVisible(false);
  }

  kill(){
    this.setActive(false).setVisible(false);
  }

  revive(x: number, y: number){
    this.setPosition(x, y);
    this.setVisible(true).setActive(true);
  }  

  preUpdate(time: number, delta: number){
    super.preUpdate(time, delta);

    if(this.active){
      // Recycle: kill enemy if it moves below camera view //
      Helpers.kill(this);
    }
  } 
}